<template>
    <el-dropdown style="display:flex">
      <img src="./img/header.png" alt="" class="user_img" />
      <el-dropdown-menu slot="dropdown" style="text-align:center">
        <el-dropdown-item @click.native="goInfo">个人学习记录</el-dropdown-item>
        <el-dropdown-item @click.native="logOut">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {

}
</script>

<style scoped>
.user_img {
  width: 42px;
  height: 42px;
  margin: 0 40px;
  cursor: pointer;
}
:deep(.el-dropdown-menu__item:hover) {
  color: #2AB18B
}
</style>